app.controller('AccountController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {

    $scope.account_choices = [];

    $rootScope.service.account.requireMinimumData(function () {

        $scope.account_choice_list = [
            {name: "Account Summary", sref: "myba.account.summary"},
            {name: "Account Details", sref: "myba.account.detail"},
            {name: "Account Discounts", sref: "myba.account.discount"},
            {name: "Live Statement", sref: "myba.account.statement"},
        ];

        if ($rootScope.service.account.isMasterAdmin()) {
            $scope.account_choice_list.push({name: "Admin Tools", sref: "myba.account.admin-tools"})
        }

    });

    $scope.isTabChoiceActive = function (tabChoice) {
        return $state.current && $state.current.name && $state.current.name.startsWith(tabChoice.sref);
    }

}]);